function DetailedDescription({ description }) {
  return (
    <div className="w-full">
      <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-200 transition-all duration-300 hover:shadow-lg">
        <h2 className="text-2xl font-bold text-gray-800 mb-4 tracking-tight">
          Bu Saha Hakkında
        </h2>
        <p className="text-gray-700 leading-relaxed">
          {description || "No description available for this pitch."}
        </p>
      </div>
    </div>
  );
}

export default DetailedDescription;
